import {
  SearchableCampaignSortableFields,
  SearchableSortDirection,
  SearchCampaignsOnDropdownQueryVariables
} from 'generated-graphql/graphql';
import { CampaignStatus } from 'generated-graphql/types';

export const getDefaultExistingCampaignQueryVariables = ({
  organizationId,
  searchText
}: {
  organizationId: string;
  searchText: string;
}): SearchCampaignsOnDropdownQueryVariables => {
  return {
    filter: {
      organizationId: {
        eq: organizationId
      },
      and: [
        !searchText
          ? {}
          : {
              title: {
                wildcard: `${searchText}*`
              }
            },
        {
          status: {
            eq: CampaignStatus.FinishedSending
          }
        },
        {
          atsJobId: {
            exists: false
          },
          atsListId: {
            exists: false
          }
        }
      ]
    },
    sort: [
      {
        field: SearchableCampaignSortableFields.CreatedAt,
        direction: SearchableSortDirection.Desc
      }
    ],
    limit: 500
  };
};
